import SaascadaVueFieldGroup from './SaascadaVueFieldGroup';

export default class SaascadaVueForm extends SaascadaVueFieldGroup {
  public validate(field: string) {
    return this.validateField(field);
  }
  public valid = true;
}